import isEmptyString from "../utils/isEmptyString";
var validMonth = function validMonth(value) {
  if (typeof value === "undefined" || isEmptyString(value)) {
    return "Month is required.";
  }
  if (typeof value === "number") {
    return value >= 1 && value <= 12 ? undefined : "Valid month required.";
  } else {
    var isValidMonth = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"].includes(value);
    return isValidMonth ? undefined : "Valid month required.";
  }
};
export default validMonth;